module.exports = __webpack_public_path__ + "0ab820095360ea2ba5c6592e4d3d587f.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/iconfont/iconfont.woff?t=1462848962
// module id = 1049
// module chunks = 75